import { GroupKeyForm } from './../../models/clash/group-key-form-dto';
import { map, Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { IResponseDto } from '@models/exceptions/response-dto';
import { ClashDto, InscricaoCabecaChaveDto } from '@models/clash/clash-dto';
import { ClashFilter, ClashFilterByHourAndLocal, ClashForm } from '@models/clash/clash-form.dto';
import { IPage } from '@models/pagination/page';
import { IPageable } from '@models/pagination/pageable';
import { toParams } from '../../utilities/utility-functions';
import { RegistrationKeyCompleteDto } from '@models/clash/clashes/registration-key-complete-dto';
import { GamesTableDto } from '@models/embate/games-table-dto';
import { GroupKeyDto } from '@models/clash/group-key-dto';

@Injectable({
  providedIn: 'root'
})
export class ClashService {
  private url: string = environment.apiUrl + "/v1/chaves-embate";

  #http = inject(HttpClient);

  getClash(cheNrId?: number): Observable<ClashDto> {
    return this.#http.get<IResponseDto<ClashDto>>(`${this.url}/${cheNrId}/embates`).pipe(
      map(response => response.response)
    )
  }
  editClash(clashForm: ClashForm): Observable<void>{ //TODO: Colocar em outro service para /v1/embate
    return this.#http.put<IResponseDto<void>>(environment.apiUrl + "/v1/embates", clashForm).pipe(
      map(response => response.response)
    )
  }

  configureClash(groupKeyForm: GroupKeyForm): Observable<void>{ //TODO: Colocar em outro service para /v1/embate
    return this.#http.put<IResponseDto<void>>(environment.apiUrl + "/v1/embates", groupKeyForm).pipe(
      map(response => response.response)
    )
  }

  getParticipants(cheNrId?: number, incTxResumo?: string, pageable?: IPageable): Observable<IPage<InscricaoCabecaChaveDto>>{
    let params = toParams({incTxResumo: incTxResumo, pageable: pageable});
    return this.#http.get<IResponseDto<IPage<InscricaoCabecaChaveDto>>>(this.url+'/'+cheNrId+'/inscricoes', {params: params}).pipe(
      map(response => response.response)
    )
  }

  searchForKeySubscribers(cheNrId?: number, incTxResumo?: string, pageable?: IPageable): Observable<IPage<RegistrationKeyCompleteDto>>{
    let params = toParams({incTxResumo: incTxResumo, pageable: pageable});
    return this.#http.get<IResponseDto<IPage<RegistrationKeyCompleteDto>>>(this.url+'/'+cheNrId+'/inscricoes', {params: params}).pipe(
      map(response => response.response)
    )
  }

  generateEmptyClash(petNrId: number): Observable<void>{
    return this.#http.get<IResponseDto<void>>(`${this.url}/${petNrId}/gerar-chaves-vazias`).pipe(
      map(response => response.response)
    )
  }
  getClashs(clashFilter: ClashFilter, pageable: IPageable):Observable<IPage<GroupKeyDto>>{
    let params = toParams({clashFilter:clashFilter, pageable:pageable})
    return this.#http.get<IResponseDto<IPage<GroupKeyDto>>>(`${this.url}`,{params:params}).pipe(
      map(response => response.response)
    )
  }


}
